/**
  不会出现在菜单中的基本路由
  wk 2020-03-03
*/
const routers = [
	{
		path: '/',
		name: 'login',
		component: () => import('../views/login/index.vue')
	},
	{
		path:'/scanningCode',
		name:'scanningCode',
		component: () => import('../views/scanningCode/index.vue')
	},
	{
		path:'/scanningCodeByPortable',
		name:'scanningCodeByPortable',
		component: () => import('../views/scanningCode/detail.vue')
	}
]

export default routers
